import { REQUESTPASSWORDTORESET, RESETPASSWORD } from "../actions/types";

const initialState = {
  passwordUpdateStatus: null,
  resetRequestStatus: null,
};

export default function (state = initialState, action) {
  switch (action.type) {
    case REQUESTPASSWORDTORESET:
      return {
        ...state,
        resetRequestStatus: action.payload,
      };
    case RESETPASSWORD:
      return {
        ...state,
        passwordUpdateStatus: action.payload,
      };

    default:
      return state;
  }
}
